import { AccountsService, DeclarationService, IAccount } from "../../services";
import * as moment from "moment";
import env from "../../config";

class ReportsHoursController implements ng.IComponentController {
    from: Date;
    till: Date;
    accounts: IAccount[] = [];
    selectedAccountId: string;
    rows: any[] = [];
    groupedRows: any[] = [];
    loading = false;

    constructor(
        private DeclarationService: DeclarationService,
        private AccountsService: AccountsService,
        private $http: ng.IHttpService,
        private localStorageService: ng.local.storage.ILocalStorageService,
        private FileSaver: ng.FileSaver
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.from = moment().startOf('month').toDate();
        this.till = moment().endOf('month').toDate();
        this.AccountsService.all().then((result) => {
            this.accounts = (result || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        });
    }

    search = () => {
        this.loading = true;
        const from = moment(this.from).format('YYYY-MM-DD');
        const till = moment(this.till).format('YYYY-MM-DD');
        const queryParams: any = { from, till };
        if (this.selectedAccountId) {
            queryParams.accountId = this.selectedAccountId;
        }

        this.DeclarationService.customAll('report-hours', queryParams)
            .then((result: any[]) => {
                this.rows = result || [];
                this.groupedRows = this.buildGroups(this.rows);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    getTotalHours = () => {
        return (this.rows || []).reduce((sum, row) => sum + (row.hours || 0), 0);
    }

    exportExcel = () => {
        if (!this.from || !this.till) {
            return;
        }

        const queryParts = [
            `from=${encodeURIComponent(moment(this.from).format('YYYY-MM-DD'))}`,
            `till=${encodeURIComponent(moment(this.till).format('YYYY-MM-DD'))}`
        ];
        if (this.selectedAccountId) {
            queryParts.push(`accountId=${encodeURIComponent(this.selectedAccountId)}`);
        }

        const downloadUrl = `${env.API_URL}declaration/report-hours-export?${queryParts.join('&')}`;
        const token = this.localStorageService.get("authorizationData");
        const headers: any = {};
        if (token) {
            headers.Authorization = 'Bearer ' + token;
        }

        this.$http.get(downloadUrl, { responseType: 'arraybuffer', headers }).then((response: any) => {
            const contentType = response.headers('Content-Type') || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const contentDisposition = response.headers('Content-Disposition') || '';
            const filenameMatch = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition);
            let fileName = `urenrapport_${moment(this.from).format('YYYYMMDD')}_${moment(this.till).format('YYYYMMDD')}.xlsx`;

            if (filenameMatch && filenameMatch[1]) {
                fileName = decodeURIComponent(filenameMatch[1].replace(/"/g, ''));
            }

            const blob = new Blob([response.data], { type: contentType });
            this.FileSaver.saveAs(blob, fileName);
        });
    }

    private buildGroups = (rows: any[]) => {
        const accountMap = new Map<string, any>();

        (rows || []).forEach((row) => {
            const accountKey = row.accountId;
            if (!accountMap.has(accountKey)) {
                accountMap.set(accountKey, {
                    accountId: row.accountId,
                    accountName: row.accountName,
                    totalHours: 0,
                    locationsMap: new Map<string, any>()
                });
            }

            const account = accountMap.get(accountKey);
            account.totalHours += row.hours || 0;

            const locationKey = row.locationId;
            if (!account.locationsMap.has(locationKey)) {
                account.locationsMap.set(locationKey, {
                    locationId: row.locationId,
                    locationName: row.locationName,
                    totalHours: 0,
                    services: []
                });
            }

            const location = account.locationsMap.get(locationKey);
            location.totalHours += row.hours || 0;
            location.services.push(row);
        });

        return Array.from(accountMap.values()).map((account: any) => {
            const locations = Array.from(account.locationsMap.values()).map((location: any) => {
                const services = (location.services || []).sort((a, b) => {
                    const dateCompare = moment(a.shiftDate).valueOf() - moment(b.shiftDate).valueOf();
                    if (dateCompare !== 0) return dateCompare;
                    return moment(a.dateTimeFrom).valueOf() - moment(b.dateTimeFrom).valueOf();
                });

                return {
                    locationId: location.locationId,
                    locationName: location.locationName,
                    totalHours: location.totalHours,
                    services
                };
            });

            locations.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));

            return {
                accountId: account.accountId,
                accountName: account.accountName,
                totalHours: account.totalHours,
                locations
            };
        }).sort((a, b) => (a.accountName || '').localeCompare(b.accountName || ''));
    }
}

export const reportsHoursComponent: ng.IComponentOptions = {
    controller: ReportsHoursController,
    template: require('./reportsHours.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/reportsHours.component.ts